import {Layout, Button, Carousel, Tabs, FloatButton,Affix} from 'antd';
import {QuestionCircleOutlined} from '@ant-design/icons';
import {useEffect, useState} from 'react';
import Script from 'react-load-script';
import $ from 'jquery';
import axios from 'axios';
import {Navigation, Pagination, Scrollbar, A11y, Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import {Link} from 'react-router-dom';    // 路由插件
import './ContentIndex.css';
const logoImg = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo2.png';
const jieshao = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xq/cma介绍图片.jpg';
const liucheng = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xq/cma办理流程图.jpg';
const yemei = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/cma.jpg';
const xia = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xq/logo至于每一个介绍最下方.png';
const logo22 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo22.png';
const weixing = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/weixing.jpg';

const {Header, Footer, Sider, Content} = Layout;
const App = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    const [top, setTop] = useState(118);
    const scroll=(y)=>{
        window.scrollTo(0, y);
    }
    function createMarkup() {
        return {__html:'<div class="neiye clearfix "><div class="nyrcon ">\n' +
                '                    <div class="nyrt"><span>CMA资质认定咨询</span></div>\n' +
                '                    <div class="nxm_xq">\n' +
                '                        <div class="nxcon">\n' +
                '                            <p style="text-align: left;"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CMA中国计量认证咨询服务：</span></strong></span></p><p style="text-align: center;"><img width="50%" style="margin: auto;" src="' +jieshao+'" /></p><p><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CMA中国计量认证简介：</span></strong></span></p><p><span style="color: rgb(0, 0, 0);">中国计量认证简称“CMA”，英文译名为“China Metrology \n' +
                'Accreditation”的缩写是根据中华人民共和国计量法的规定，由省级以上人民政府计量行政部门对检测机构的检测能力及可靠性进行的一种全面的认证及评价。这种认证对象是所有对社会出具公正数据的产品质量监督检验机构及其它各类实验室；如各种产品质量监督检验站、环境检测站、疾病预防控制中心等等。取得计量认证合格证书的检测机构，允许其在检验报告上使用<a  target="_self">CMA计量认证</a>标记。</span></p><p><a  target="_self"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">申请CMA资质认定</span></strong></span></a><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">的条件：</span></strong></span></p><p><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);"></span></strong></span></p><p><span style="color: rgb(0, 0, 0);">1、依法成立并能够承担相应法律责任的法人或者其他组织；</span></p><p><span style="color: rgb(0, 0, 0);">2、具有与其从事检验检测活动相适应的检验检测技术人员和管理人员；</span></p><p><span style="color: rgb(0, 0, 0);">3、具有固定的工作场所，工作环境满足检验检测要求；</span></p><p><span style="color: rgb(0, 0, 0);">4、具备从事检验检测活动所必需的检验检测设备设施；</span></p><p><span style="color: rgb(0, 0, 0);">5、具有并有效运行保证其检验检测活动独立、公正、科学、诚信的管理体系，并且有效运行6个月以上；</span></p><p><span style="color: rgb(0, 0, 0);">6、符合有关法律法规或者标准、技术规范规定的特殊要求。</span></p><p><span style="color: rgb(0, 0, 0);"><span style="color: rgb(54, 96, 146); font-size: 16px; font-family: arial, helvetica, sans-serif;"><strong><span style="font-size: 16px; color: rgb(54, 96, 146);">CMA<span style="font-size: 16px; color: rgb(54, 96, 146);">检验检测机构资质申请流程：</span></span></strong></span><span style="color: rgb(54, 96, 146);"><strong><span style="color: rgb(0, 0, 0); font-size: 14px; font-family: 宋体;"></span></strong><strong><span style="color: rgb(0, 0, 0); font-size: 14px; font-family: 宋体;"></span></strong></span><span style="font-size: 14px; color: rgb(0, 0, 0);"><span style="color: rgb(0, 0, 0); font-size: 14px; font-family: 宋体;"></span><strong><span style="color: rgb(0, 0, 0); font-size: 14px; font-family: &quot;Times New Roman&quot;;"><br></span></strong></span><span style="color: rgb(0, 0, 0); font-size: 14px; font-family: 宋体;"></span></span></p><p><span style="color: rgb(0, 0, 0);">1、网上注册；</span></p><p><span style="color: rgb(0, 0, 0);">2、网上申报按要求填写相关文件(申报能力，授权签字人明细，简历，组织机构，检测人员明细，仪器设备配置表，质量手册，程序文件，内审报告，管理评审报告，典型报告，试验场地证明，人员劳动合同，社保证明，技术负责人、质量负责人培训证书、内审员证、检测人员技术资格证书等)；</span></p><p><span style="color: rgb(0, 0, 0);">3、网上后台会显示进度，文审通过后下受理通知书；</span></p><p><span style="color: rgb(0, 0, 0);">4、申请书、附表及附件现场评审时交给组长；</span></p><p><span style="color: rgb(0, 0, 0);">5、安排现场评审；</span></p><p><span style="color: rgb(0, 0, 0);">6、整改时间一般为两个月；</span></p><p><span style="color: rgb(0, 0, 0);">7、获准资质认定后，去服务大厅领取证书。</span></p><p style="text-align: left;"><span style="font-size: 16px; font-family: arial, helvetica, sans-serif; color: rgb(0, 0, 0);"><strong style="text-align: center;"><span style="font-family: arial, helvetica, sans-serif; font-size: 16px; color: rgb(54, 96, 146);">CMA检验检测机构资质认定办事流程：</span></strong></span></p><p style="text-align: center;"><img width="50%" style="margin: auto;" src="' +liucheng+'" /></p>                        </div>\n' +
                '                    </div>\n' +
                '                </div></div>'};
    }

    return (

        <>
            <FloatButton.BackTop visibilityHeight={0}  style={{zIndex:9999999999999999}}/>
            <div className="fixed is_PC"></div>
            <div className="all_width is_PC">

                <div className="warp">
                    <div className="header">
                         <div className="logo"><a href="#/ContentIndex" style={{float:"left",marginRight:15}}><img src={logoImg} height={108}/></a></div>
                        <div className="new_nav">
                           <ul>
                                <li><a href="#/ContentIndex">首页</a></li>
                                <li><a  href="#/cnas">CNAS认可</a></li>
                                <li><a  href="#/cma">CMA认定</a></li>
                                <li><a  href="#/fanghuo">防火检测</a></li>
                                <li><a  href="#/haishui">海水腐蚀</a></li>
                                <li><a  href="#/jingxiang">金相抛光布</a></li>
                                <li><a   href="#/about">关于我们</a></li>
                            </ul>
                        </div>

                        <div className="vub_B" style={{position:"fixed",top:"30px"}}>联系电话： 18957441030</div>
                    </div>
                </div>
            </div>

            <div style={{position:'relative'}}>
                {/*<img src={bannerBG}/>*/}
                <img src={yemei} width={'100%'}/>
                <div style={{position:"absolute",top:'15%',left:'50px',fontSize:50,color:'#fff',fontWeight:"bold",width:1000,textAlign:"center"}}>
                    <span>CMA检验检测资质认定/RBT214-2017</span><br />
                    <span>上门服务 保证一次性通过</span><br />
                    <span style={{fontWeight:100,fontSize:31}}>准则宣贯、文件编制、内部审核、管理评审、质量记录、技术记录。</span>
                </div>
            </div>
            <div className={'service-details'} >
                <Affix offsetTop={top}>
                    <div className="l-box" >
                        <div className="s-plate">
                            <div className="d-nav">
                                <ul>
                                    <li onClick={event => scroll(529)}>
												<span>
													<i></i>CMA中国计量认证咨询服务</span>
                                    </li>
                                    <li onClick={event => scroll(872)}>
												<span>
													<i></i>CMA中国计量认证简介</span>
                                    </li>
                                    <li className=""  onClick={event => scroll(1010)}>
												<span>
													<i></i>申请CMA资质认定的条件												</span>
                                    </li>
                                    <li className="" onClick={event => scroll(1272)}>
												<span>
													<i></i>CMA检验检测机构资质申请流程</span>
                                    </li>
                                    <li className="" onClick={event => scroll(1608)}>
												<span>
													<i></i>CMA检验检测机构资质认定办事流程</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Affix>

                <div className={'r-box'}>
                    <div dangerouslySetInnerHTML={createMarkup()} />
                </div>
            </div>
            <img src={xia} width={'100%'} style={{zIndex:999,position:"relative",marginTop:80,display:"block"}}/>
             <div className="all_fnav is_PC" style={{zIndex:999,position:"relative"}}>
                 <div style={{background:'#fff',height:80}}></div>
                <div className="warp">
                    <div className={'b'}>
                        <img src={logo22} height={108} style={{float:"left"}}/>
                        <div style={{float:"right",lineHeight:'108px',fontSize:'26px',paddingRight:40}}>致力于我国实验室建设、 认证、 扩项、 监督评审、 一站式解决方案</div>
                    </div>
                    <div className="Fanya_footer_nav" style={{color:'#FFF'}}>
                        <ul>
                            <li>
                                
                                <div className="Fanya_footer_nav_TT">CMA资质认定</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>检验检测机构CMA资质认定</dt>
                                        <dt>机动车检验机构CMA资质认定</dt>
                                        <dt>司法鉴定机构CMA资质认定</dt>
                                        <dt>刑事技术机构CMA资质认定</dt>
                                    </dl>
                                </div>
                            </li>
                            <li><div className="Fanya_footer_nav_TT">CNAS认证认可</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>ISO17025检测/校准实验室CNAS认可</dt>
                                        <dt>ISO17020检验机构CNAS认可</dt>
                                        <dt>ISO15189医学实验室CNAS认可</dt>
                                        <dt>DILAC国防实验室认可</dt>
                                    </dl>
                                </div>
                            </li>
                            <li style={{marginRight:15}}>
                                <div className="Fanya_footer_nav_TT">联系我们</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>电话：0574-87636695</dt>
                                        <dt>认证热线：18957441030（胡老师）</dt>
                                        <dt>地址：宁波市高新区检验检测园冬青路258号A幢</dt>
                                        <dt></dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div className="Fanya_footer_sub" style={{position:"relative"}}>
                                    <img src={weixing} width={160} />
                                    <div style={{background:'red',borderRadius:16,lineHeight:'32px',textAlign:"center",width:160,marginTop:10}}>扫码咨询</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="all_Fanya_copyright">
                <div className="warp">
                    <div className="Fanya_copyright">版权所有 ◎ 浙江安鉴检测认证服务有限公司 <a
                        href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2024103308号-1</a></div>
                </div>
            </div>
        </>
);
};
export default App;
